<template>
    <div class="mt-2">

        <v-container>
            <v-layout row wrap class="justify-space-around">
                <v-flex xs12 sm12 md9 >
                    <v-card class="mx-2">
                        <v-card-text>
                            <div>
                                <h1>Le retrait de points du permis de conduire</h1>
                                <p>
                                    Quelle que soit la nature de l’infraction, alcoolémie au volant, stop non respecté, excès de
                                    vitesse, que le retrait de point est effectué. La classification de la contravention détermine le
                                    nombre de points qui seront retirés.
                                </p>
                                <p>
                                    La date de l’infraction constitue le commencement d’un processus juridique automatique.
                                    Celui-ci peut toujours faire l’objet d’une contestation devant le tribunal. Dans tous les cas,
                                    les points ne seront décomptés de votre solde administratif que plusieurs mois après
                                    l’infraction.
                                </p>
                            </div>

                            <div>
                                <h2>Comment fonctionne le retrait de points</h2>
                                <p>
                                    Tout conducteur qui commet une infraction peut se voit retiré des points, conformément au
                                    Code de la Route ( article R 223-3 du Code de la Route).
                                </p>
                                <p>
                                    Il existe un rapport de proportionnalité entre la gravité de l’infraction commise et
                                    le nombre de points retirés. Celui-ci est défini par le barème des infractions.
                                </p>
                                <p>
                                    Si le conducteur commet plusieurs infractions en même temps, il peut perdre
                                    jusqu’à 8 points ( article R223-2 du Code de la Route).
                                </p>
                                <p>
                                    Tout conducteur dont le solde de points se retrouve fragilisé reçoit la lettre 48M.
                                    Celle-ci l’informe que le solde de points de son permis de conduire est inférieur ou
                                    égal à 6 points et qu’il peut donc suivre un stage de récupération de points.
                                </p>
                                <p>
                                    Tout conducteur ayant perdu l’intégralité de ses points a la possibilité de suivre un
                                    stage au sein d’une centre agréé sans avoir encore reçu la lettre 48SI qui
                                    l’informera que son permis a été invalidé.
                                </p>
                            </div>

                            <div>
                                <h2>Le retrait de points en 3 temps</h2>
                                <p>
                                    L’infraction est constatée par les forces de l’ordre qui n’effectuent pas le retrait des points.
                                    En effet, le retrait est pris en charge par l’administration et la justice.
                                </p>
                                <p>
                                    La prise en compte juridique de la perte de points et son effet administratif ne sont pas
                                    simultanés.
                                </p>
                                <p>
                                    Les 3 temps du retrait de points :
                                </p>
                                <ul>
                                    <li>1. Date et heure de l’infraction notifiés par le tribunal de police ou le tribunal
                                        correctionnel
                                    </li>
                                    <li>2. Paiement de l’amende enregistré par le Trésor Public. Cette étape déclenche le
                                        retrait de points par la Préfecture
                                    </li>
                                    <li>
                                        3. Retrait de points par la Préfecture (Ministère de l’Intérieur) entre 2 et 12 mois après
                                        l’infraction
                                    </li>
                                </ul>
                            </div>

                            <div>
                                <h2>Le long processus du retrait</h2>
                                <p>Les étapes relatives au retrait de points sont nombreuses :</p>
                                <ul>
                                    <li>Les forces de l’ordre constatent l’infraction</li>
                                    <li>Le conducteur attend l’avis de contravention</li>
                                    <li>L’amende est payée par courrier recommandé. Possibilité de la contester e, justice en
                                        ayant recours à un avocat</li>
                                    <li>Le paiement ou la condamnation sont pris en compte</li>
                                    <li>Le retrait de points est enregistré sur le F.N.P.C.</li>
                                    <li>Le conducteur reçoit le courrier qui l’informe que ses points ont été retirés.</li>
                                </ul>
                                <p>
                                    Toutes ces étapes se déroulent sur une période allant de plusieurs semaines à plusieurs
                                    mois.
                                </p>
                            </div>

                            <div>
                                <h2>L’utilité de ce délai</h2>
                                <p>
                                    Tout le temps que prend le processus du retrait de points permet au conducteur de gagner
                                    du temps afin de pouvoir récupérer des points et contester l’infraction.
                                </p>
                                <p>
                                    Suivre un stage de sensibilisation à la sécurité routière permet au conducteur de récupérer 4
                                    points.
                                </p>
                                <p>
                                    La contestation de l’infraction devant un tribunal peut se faire avec l’assistance d’un avocat
                                    spécialisé en droit routier.
                                </p>
                                <p>
                                    À partir de ce moment et jusqu’à ce que toutes les voies de recours soient épuisées et la
                                    décision de relaxe ou condamnation prononcée, la procédure de retrait de points en
                                    suspendue.
                                </p>
                                <p>
                                    La très grande majorité des recours se concluent par une condamnation du conducteur.
                                    Cependant, les 18 mois gagnés par la procédure laissent au conducteur le temps nécessaire
                                    à la reconstitution partielle ou complète de son solde de points. En effet, il est possible de
                                    suivre un stage de sensibilisation à la sécurité routière tous les 12 mois.
                                </p>
                            </div>

                            <div>
                                <h2>À quel moment suivre un stage de récupération de points</h2>
                                <p>
                                    À partir du moment où votre solde atteint les 6 points, nous vous conseillons de suivre un
                                    stage de récupération de points.
                                </p>
                                <p>
                                    Au moment où votre permis de conduire atteint le solde de 6 points, vous recevrez la lettre
                                    recommandée 48M envoyée par le Ministère de l’Intérieur. Celle-ci a pour vocation de vous
                                    inciter à suivre un stage volontaire de sensibilisation à la sécurité routière.
                                </p>
                                <p>
                                    Seuls les conducteurs confirmés possédant un permis sur 12 points reçoivent ce courrier. En
                                    effet, les jeunes conducteurs détenteurs d’un permis probatoire se voient adressé la lettre
                                    recommandée 48N en cas d’infraction engendrant une perte d’au moins 3 points. Après
                                    réception de ce courrier, ils doivent suivre un stage obligatoire de récupération de points.
                                </p>
                            </div>

                            <div>
                                <h2>Le retrait de la totalité des points</h2>
                                <p>
                                    Veiller à consulter votre solde de points si vous avez commis plusieurs infractions routières.
                                    Ceci vous évitera de voir votre permis de conduire atteindre un solde nul et donc être
                                    invalidé. La lettre recommandée avec accusé de réception 48SI signifie l’invalidation du
                                    permis de conduire. Il sera alors trop tard pour récupérer des points. Il ne reste qu’une
                                    solution : repasser le permis de conduire et se soumettre à une visite médicale et un test
                                    psychotechnique.
                                </p>
                                <p>
                                    Les jeunes conducteurs détenteurs d’un permis probatoire ont l’obligation de repasser à la
                                    fois le code de la route et l’épreuve pratique. Seul le code de la route doit être repassé par
                                    les autres conducteurs.
                                </p>
                            </div>

                        </v-card-text>
                    </v-card>

                </v-flex>
                <v-flex xs12 sm12 md3>
                    <v-card class="mx-2">
                        <v-card-text>
                            <RightAsideInfractions></RightAsideInfractions>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>

        <Footer />
    </div>
</template>

<script>
    import RightAsideInfractions from '@/components/RightAsideInfractions'
    import Footer from '@/components/Footer'

    export default {
        name: "stage-recuperation-points",
        components: {
            RightAsideInfractions,
            Footer
        }
    }
</script>

<style>
    .highlighted {
        background: #ffedf5;
        border-radius: 10px;
        color: #7a0439;
        font-size: 18px;
        font-weight: 800;
        padding: 10px;
    }

    .highlighted p {
        font-size: 18px;
    }

    ul li {
        list-style-type: circle;
        margin: 10px 0 10px 0;
    }

    a {
        text-decoration: none;
    }

    a:hover {
        color: black;
    }

    p {
        font-size: 16px;
    }
</style>
